/**
 * useVerticalCard.ts
 */
import Card from '@shared/types/props/card';
import ChannelUtils from '@shared/utils/channels';
import Event from '@shared/classes/event';
import MainContext from '@shared/components/utils/context/mainContext';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useMemo, useState } from 'react';

/**
 * Hook for the vertical card component.
 */
export default function useVerticalCard({
  focused,
  item,
  showInfo = true,
  onClick,
}: Card) {
  // Selectors
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { hoverAsset } = useContext(MainContext);

  // States
  const [hovered, setHovered] = useState(false);

  // Memoized data
  return useMemo(() => {
    // Fetch upgradable plan
    const upgradablePlan = ChannelUtils.getUpgradablePlan(
      (item as Event)?.channel,
      false,
      item.type
    );

    // Return display and props
    return {
      display: {
        info: showInfo,
      },
      props: {
        container: {
          onClick,
          onMouseEnter: () => {
            setHovered(true);
            hoverAsset(item);
          },
          onMouseLeave: () => {
            setHovered(false);
          },
        },
        image: {
          src: (item as Event)?.poster || (item as Event)?.photo,
        },
        info: {
          item,
          focused: (!enabled && focused) || hovered,
          plan: upgradablePlan,
        },
      },
    };
  }, [onClick, hoverAsset, setHovered, enabled, hovered, focused, item]);
}
